import { CacheRules } from '../../../../../interfaces/WidgetInterfaces';

import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-cache-rule-editor',
  template: `<div>
  <div class="form-group row">
    <label for="description" class="col-sm-2 col-form-label tightPad">period</label>
    <div class="col-sm-10 tightPad">
      <select class="form-control" [(ngModel)]="cacheRules.period">
                        <option *ngFor="let period of periods" [ngValue]="period">{{period}}</option>
                    </select>
    </div>
  </div>

  <div class="form-group row">
    <label for="description" class="col-sm-2 col-form-label tightPad">frequency</label>
    <div class="col-sm-10 tightPad">
      <input class="form-control" type="text" [(ngModel)]="cacheRules.frequency" id="description">
    </div>
  </div>

  <div class="form-group row">
    <label for="description" class="col-sm-2 col-form-label tightPad">target Minute</label>
    <div class="col-sm-10 tightPad">
      <input class="form-control" type="text" [(ngModel)]="cacheRules.targetMinute" id="description">
    </div>
  </div>

  <div class="form-group row">
    <label for="description" class="col-sm-2 col-form-label tightPad">target Hour</label>
    <div class="col-sm-10 tightPad">
      <input class="form-control" type="text" [(ngModel)]="cacheRules.targetHour" id="description">
    </div>
  </div>

  <div class="form-group row">
    <label for="description" class="col-sm-2 col-form-label tightPad">target Day</label>
    <div class="col-sm-10 tightPad">
      <input class="form-control" type="text" [(ngModel)]="cacheRules.targetDay" id="description">
    </div>
  </div>

  <div class="form-group row">
    <label for="description" class="col-sm-2 col-form-label tightPad">target WorkWeek Day</label>
    <div class="col-sm-10 tightPad">
      <input class="form-control" type="text" [(ngModel)]="cacheRules.targetWorkWeekDay" id="description">
    </div>
  </div>
</div>`,
  styles: [``]
})
export class CacheRuleEditorComponent implements OnInit {

  @Input() cacheRules: CacheRules;

  periods = [
          '',
          'hour',
          'minute',
          'day',
          'week',
          'never',
          'month',
          'permanent'
        ];

  constructor() { }

  ngOnInit() {
  }

}
